import React , { useEffect , useContext } from 'react';
import HomeContent from '../../Components/HomeContent/HomeContent';
import HomeImage from '../../Components/HomeImage/HomeImage';

import "./Home.css";
import { useParams } from "react-router-dom"
import { Decrypt } from '../../utils/Decrypt';
import MainContext from '../../context/Main/MainContext';


function Home() {
  const { rmDetails } = useParams()
  const { merchantDetails , setMerchantDetails , setError} = useContext(MainContext)

  const decrypt = async () => {
    // const details = await Decrypt(rmDetails)
    // return details
    let merchantDetails = null;
    try {
      let decryptPath = await Decrypt(rmDetails);
      setMerchantDetails(decryptPath)
    } catch (er) {
      setError(
        "The path you've entered is incorrect. Please check and update the path, then try again"
      );
 
      return;
    }
  }
 useEffect(()=>{
   decrypt()
 },[])

  return (
    <div className='home'>
          <HomeImage/>
         <HomeContent/>
    </div>
  );
}

export default Home;
